import { Component } from '@angular/core';

@Component({
  selector: 'i-backspace',
  imports: [],
  template: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 32" fill="none">
    <path
      d="M18.8 24L24 18.8L29.2 24L32 21.2L26.8 16L32 10.8L29.2 8L24 13.2L18.8 8L16 10.8L21.2 16L16 21.2L18.8 24ZM14 32C13.3667 32 12.7667 31.8583 12.2 31.575C11.6333 31.2917 11.1667 30.9 10.8 30.4L0 16L10.8 1.6C11.1667 1.1 11.6333 0.708333 12.2 0.425C12.7667 0.141667 13.3667 0 14 0H36C37.1 0 38.0417 0.391667 38.825 1.175C39.6083 1.95833 40 2.9 40 4V28C40 29.1 39.6083 30.0417 38.825 30.825C38.0417 31.6083 37.1 32 36 32H14ZM5 16L14 28H36V4H14L5 16Z"
      fill="currentColor"
    />
  </svg>`,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconBackspace {}
